import React from "react";
import AspectRatio from "@mui/joy/AspectRatio";
import CardContent from "@mui/joy/CardContent";
import IconButton from "@mui/joy/IconButton";
import Typography from "@mui/joy/Typography";
import BookmarkAdd from "@mui/icons-material/BookmarkAddOutlined";
import styles from "./InfoWindow.module.css";

const InfoWindow = ({ listing, onClick }) => {
  function formatMoney(number) {
    if (typeof number === "number") {
      return new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      }).format(number);
    }
    return number;
  }

  return (
    <div className={styles.infoWindowContainer} onClick={onClick}>
      {listing.pro_id && <span className={styles.proTag}>Pro</span>}

      <AspectRatio minHeight="120px" maxHeight="200px">
        <img src={listing.image_url} loading="lazy" alt={listing.address} />
      </AspectRatio>

      <CardContent orientation="vertical">
        {/* Sell Price */}
        <Typography level="h5" className={styles.listingSellPrice}>
          {formatMoney(listing.sell_price)}
        </Typography>

        {/* Property Details */}
        <Typography level="body2" className={styles.listingInfo}>
          {listing.bedrooms} bds | {listing.bathrooms} ba | {listing.area_sqft}{" "}
          sqft
        </Typography>

        <Typography level="body2" className={styles.listingStatus}>
          {listing.address}
        </Typography>

        <Typography level="body2">
          {listing.city}, {listing.state} {listing.zipcode}
        </Typography>
      </CardContent>

      {/* Actions */}
      <div className={styles.listingActions}>
        <IconButton
          aria-label="bookmark"
          variant="plain"
          color="neutral"
          size="sm"
          sx={{ position: "absolute", top: "0.5rem", right: "0.5rem" }}
        >
          <BookmarkAdd />
        </IconButton>
      </div>
    </div>
  );
};

export default InfoWindow;
